export default __webpack_public_path__ + "static/media/alluzy.22d6a762.png";